import { utils } from 'apprise-core/utils';
import { StateProvider } from 'apprise-frontend-core/state/provider';
import { createContext, PropsWithChildren, useContext, useRef } from "react";
import { fallbackStateOver, State } from "./api";



// factories that return context providers and hooks to access their state.
// context is abstracted over as an implementation details.
// default and initial state can be partial are merged.

// since 07/2025

// generates provider and access hook for mutable state.
// wraps around a StateProvider.

export const createProvider = <S extends any>(initial?: Partial<S>) => {

  const context = createContext<State<S>>(fallbackStateOver(initial))

  const useProvider = () => useContext(context)

  const Provider = (props: PropsWithChildren<Partial<S>>) => {

    const { children, ...rest } = props

    const initialState = utils().merge(initial ?? {}, utils().pruneFrom(rest).ifMissing()) as S

    return <StateProvider initialState={initialState} context={context}>
      {children}
    </StateProvider>

  }

  return [Provider, useProvider, context] as [typeof Provider, typeof useProvider, typeof context]

}

// generates provider and access hook for immutable state.

// wraps around a vannilla context provider.

export const createReadonlyProvider = <S extends any>(initial?: Partial<S>) => {

  const Context = createContext<S>(initial as S)

  const useProvider = () => useContext(Context)

  const Provider = (props: PropsWithChildren<Partial<S>>) => {

    const { children, ...rest } = props

    const initialState = useRef( utils().merge(initial ?? {}, utils().pruneFrom(rest).ifMissing()) as S)

    return <Context.Provider value={initialState.current} >
      {children}
    </Context.Provider>

  }

  return [Provider, useProvider] as [typeof Provider, typeof useProvider]

}
